import { render } from "./ListeProduit.vue?vue&type=template&id=b72fe306&scoped=true&ts=true"
import script from "./ListeProduit.vue?vue&type=script&lang=ts"
export * from "./ListeProduit.vue?vue&type=script&lang=ts"

import "./ListeProduit.vue?vue&type=style&index=0&id=b72fe306&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72fe306"]])

export default __exports__